import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { BrowserTabTitle } from '../BrowserTabTitle';
import { PageTitle } from '../PageTitle';
import { CatalogGrid } from '../catalog/CatalogGrid';

import { useAccount } from '../../auth';
import { getEntityType, getEntityCreateVerb } from '../../utils/entities';
import { capitalize } from '../../utils/strings';

export const EntityCatalog = () => {
  const { currentAccount } = useAccount();
  const navigate = useNavigate();
  const { pluralEntityType } = useParams();
  const entityType = getEntityType(pluralEntityType);
  const createVerb = getEntityCreateVerb(entityType);

  const handleItemSelect = (catalogType: any) => {
    navigate(
      `/${currentAccount.name}/${pluralEntityType}/${createVerb}/${catalogType.name}`,
    );
  };

  return (
    <>
      <PageTitle />
      <div
        style={{
          paddingBottom: 20,
          maxWidth: 1200,
          margin: '0 auto',
          marginTop: '40px',
        }}
      >
        <BrowserTabTitle>
          {capitalize(createVerb) + ' ' + capitalize(entityType)}
        </BrowserTabTitle>
        <CatalogGrid
          itemType={entityType}
          itemSelectText={capitalize(createVerb)}
          onItemSelect={handleItemSelect}
        />
      </div>
    </>
  );
};
